<template>
  <div>
    <Landing1Hero />
    <Landing2Solution />
    <Landing3HowItWorks />
    <Landing3OurProduct1 />
    <Landing4WeHelpYou />
    <Achievements />
    <Landing5Testimonials />
    <Landing6SignUp />
    <Landing7Faqs />
  </div>
</template>

<script>
// @ is an alias to /src
import Landing1Hero from "@/components/Landing1Hero.vue";
import Landing2Solution from "@/components/Landing2Solution.vue";
import Landing3HowItWorks from "@/components/Landing3HowItWorks.vue";
import Landing3OurProduct1 from "@/components/Landing3OurProduct1.vue";
import Landing4WeHelpYou from "@/components/Landing4WeHelpYou.vue";
import Achievements from "@/components/Achievements.vue";
import Landing5Testimonials from "@/components/Landing5Testimonials.vue";
import Landing6SignUp from "@/components/Landing6SignUp.vue";
import Landing7Faqs from "@/components/Landing7Faqs.vue";

export default {
  name: "Home",
  components: {
    Landing1Hero,
    Landing2Solution,
    Landing3HowItWorks,
    Landing3OurProduct1,
    Landing4WeHelpYou,
    Landing5Testimonials,
    Achievements,
    Landing6SignUp,
    Landing7Faqs,
  },
  data: () => ({
  }),
};
</script>
